import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadAddEditService {
  form: FormGroup
  // myForms: FormGroup[] = [];
  breakTimeArray = [{breakStartTime: '', breakEndTime: '', breakType: '', breakHours: '', extraFacilityArray: [{facilityName: '', facilityType: '', facilityAmount: ''}]}];
  extraFacilityArray = [{facilityName: '', facilityType: '', facilityAmount: ''}];

  constructor(private fb: FormBuilder) {
    this.initForm();
    // this.myForms.push(this.buildMyForm());
  }

  initForm(){
    this.form = this.fb.group({
      logon: ["", Validators.required],
      routeId: ["", [Validators.required, Validators.minLength(2)]],
      billOfLading: ["", Validators.required],
      productId: ["", Validators.required],
      productName: ["", Validators.required],
      quantity: ["", Validators.required],
      routeStatus: ["", Validators.required],
      scac: ["", Validators.required],
      punchIn: ["", Validators.required],
      punchOut: ["", Validators.required],
      date: ["", Validators.required],
      latitude: [],
      longitude: [],
      break : this.fb.group({
        latitude: ["", Validators.required],
        longitude: ["", Validators.required],
        breakTimes: this.fb.array(this.breakTimeArray.map(
          breakTimeArray => this.fb.group({
            breakStartTime: ["", Validators.required],
            breakEndTime: ["", Validators.required],
            breakType: ["", Validators.required],
            breakHours: ["", Validators.required],
            extraFacilities: this.fb.array(this.extraFacilityArray.map(
              facilityArray => this.fb.group(facilityArray)
            ))
          })
        )),

      })
    });
  }

 breakTimeArrayDynamic(): FormGroup{
    return this.fb.group({
      breakStartTime: ["", Validators.required],
      breakEndTime: ["", Validators.required],
      breakType: ["", Validators.required],
      breakHours: ["", Validators.required],
      extraFacilities: this.fb.array(this.extraFacilityArray.map(
        facilityArray => this.fb.group(facilityArray)
      ))
    });
  }

  extraTimeArrayDynamic(): any{
    return this.fb.group({
      facilityName: ["", Validators.required],
      facilityType: ["", Validators.required],
      facilityAmount: ["", Validators.required]
    });
  }

  get breakTimes(): FormArray{return this.form.get('break').get('breakTimes') as FormArray}
  get extraFacilities(): FormArray{return this.form.get('extraFacilities') as FormArray}

  addBreakTime(){
    this.breakTimes.push(this.breakTimeArrayDynamic());
  }

  addExtraTime(i){
    (this.breakTimes.controls[i].get('extraFacilities') as FormArray).push(this.extraTimeArrayDynamic());
  }

  // breakTImes : //array of breaks
/**
 * { breakStartTIme
 * breakEndTIme,
 * BreakTYpe,
 * BreakHours,
 * extraFacilities: [
 * {facilityName, facilityType, facilityAmount},
 * {facilityName, facilityType, facilityAmount}
 * ]
 * }
 *
 */

  buildMyForm(myForm?){
    this.form.patchValue(myForm);
    console.log(this.form)
  }

  saveMyForm(){

  }

  get loadAddEditForm(){return this.form;}

  get getControls(){
    return this.form.controls;
  }

  get breakForm(){return this.loadAddEditForm.controls["break"] as FormGroup;}
  get extraFacilitiesForm(){return this.loadAddEditForm.controls["extraFacilities"] as FormArray;}

  validateForm(){
    return this.form.valid;
  }

  submitValue(form){
    console.log(form);
  }
}


